import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = { class: "gift_box_area is_buy" }
const _hoisted_4 = { class: "buy_area_list" }
const _hoisted_5 = { class: "buy_area" }
const _hoisted_6 = { class: "buy_date" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "lst_item_area" }
const _hoisted_9 = { class: "sender" }
const _hoisted_10 = { class: "quantity" }
const _hoisted_11 = { class: "btn_cancel_area" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("구매 내역이 없습니다.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_navigator = _resolveComponent("navigator")
  const _component_sub_navigator = _resolveComponent("sub-navigator")
  const _component_ticket_list_item = _resolveComponent("ticket-list-item")
  const _component_no_ticket_component = _resolveComponent("no-ticket-component")
  const _component_toTop = _resolveComponent("toTop")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", {
      id: "content",
      class: ["content bg_gray", {'is_complete': _ctx.isEmpty}]
    }, [
      _createVNode("div", {
        class: ["tab_menu", {'fixed': _ctx.isEmpty}]
      }, [
        _createVNode(_component_navigator, { "navigator-code": "my" }),
        _createVNode(_component_sub_navigator, { "navigator-code": "myOrder" })
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("ul", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderGroupedByDate, ([key, orders]) => {
            return (_openBlock(), _createBlock("li", { key: key }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("strong", _hoisted_7, _toDisplayString(key), 1)
                ]),
                _createVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(orders, (order) => {
                    return (_openBlock(), _createBlock(_component_ticket_list_item, {
                      key: order.orderId,
                      item: order.productInfo,
                      onMoveToDetailPage: ($event: any) => (_ctx.moveToDetailPage(order.orderId))
                    }, {
                      senderOrRecipent: _withCtx(() => [
                        _createVNode("p", _hoisted_9, "to. " + _toDisplayString(order.repReceiverName), 1)
                      ]),
                      ticketCount: _withCtx(() => [
                        _createVNode("div", _hoisted_10, "총 " + _toDisplayString(order.ticketCount) + "개", 1)
                      ]),
                      cancelButton: _withCtx(() => [
                        _createVNode("div", _hoisted_11, [
                          (order.isCancelable)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                onClick: _withModifiers(($event: any) => (_ctx.moveToDetailPage(order.orderId)), ["prevent"]),
                                type: "button",
                                class: "btn_cancle"
                              }, _toDisplayString(order.orderTypeString) + "취소", 9, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["item", "onMoveToDetailPage"]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ], 512), [
        [_vShow, !_ctx.isFirstLoading && !_ctx.isEmpty]
      ]),
      _createVNode(_component_no_ticket_component, {
        isEmpty: !_ctx.isFirstLoading && _ctx.isEmpty,
        showGiftImage: false
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["isEmpty"])
    ], 2),
    _createVNode(_component_toTop)
  ], 2))
}